/**
 * This enum is used to define the control size
 */
export enum ControlSize {
  /**
   * The small size
   */
  Small = 'small',

  /**
   * The medium size
   */
  Medium = 'medium',

  /**
   * The large size
   */
  Large = 'large',
}
